<template>
  <div>
    <h4 class="text-primary">Este paso será agregado después de ti</h4>
    <form data-vv-scope="flow-part-1">
      <div class="row">
        <div class="col-6">
          <vs-select
            class="w-100"
            autocomplete
            label="Tipo de paso"
            name="stepType"
            v-model="newStep.stepType"
            :danger="errors.has('flow-part-1.stepType')"
            :danger-text="errors.first('flow-part-1.stepType')"
            v-validate="'required'"
          >
            <vs-select-item
              :value="stepTypes.USER"
              text="Usuario"
            />
            <vs-select-item
              :value="stepTypes.GROUP"
              text="Grupo"
            />
          </vs-select>
        </div>
        <div class="col-6">
          <vs-select
            class="w-100"
            autocomplete
            label="Tipo de rol"
            name="rolType"
            v-model="newStep.rolType"
            :danger="errors.has('flow-part-1.rolType')"
            :danger-text="errors.first('flow-part-1.rolType')"
            v-validate="'required'"
          >
            <vs-select-item
              :value="rolTypes.APPROVER"
              text="Aprobador"
            />
            <vs-select-item
              :value="rolTypes.REVIEWER"
              text="Revisor"
            />
            <vs-select-item
              v-if="!isSigner && !hasSignaturePosition"
              :value="rolTypes.SIGNER"
              text="Firmante"
            />
          </vs-select>
        </div>
        <div class="col-12 mt-4">
          <div v-if="newStep.stepType === stepTypes.USER">
            <list-user
              class="w-100"
              autocomplete
              label="Usuario"
              name="userStep"
              v-model="newStep.responsable"
              ref="userStep"
              :danger="errors.has('flow-part-1.userStep')"
              :danger-text="errors.first('flow-part-1.userStep')"
              v-validate="{ required: newStep.stepType === stepTypes.USER }"
            />
          </div>
          <div v-if="newStep.stepType === stepTypes.GROUP">
            <list-groups
              class="w-50"
              autocomplete
              label="Grupo"
              name="groupStep"
              :typeList="newStep.stepType"
              v-model="newStep.responsable"
              ref="groupStep"
              :danger="errors.has('flow-part-1.groupStep')"
              :danger-text="errors.first('flow-part-1.groupStep')"
              v-validate="{ required: newStep.stepType === stepTypes.GROUP }"
            />
          </div>
        </div>
      </div>
    </form>
    <div class="mt-4 text-right">
      <b-button
        data-cy="cancel-add-step"
        variant="secondary"
        v-on:click="cancelAction()"
      >
        Cancelar
      </b-button>
      <b-button
        data-cy="add-step-process"
        variant="primary"
        class="ml-2"
        v-on:click="handleOk()"
      >
        Agregar paso
      </b-button>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

import ListUser from '@/febos/chile/lists/components/ListUser';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import {rolTypesCode, stepTypesCode} from '@/febos/chile/approvals/components/trays/managementTray/constants';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import { addStepFlow } from '@/febos/servicios/api/aprobaciones.api';

export default {
  components: {
    ListUser,
    ListGroups
  },
  data() {
    return {
      newStep: {},
      stepTypesCode,
      rolTypes: RolTypes,
      stepTypes: StepTypes,
    };
  },
  computed: {
    ...mapGetters('Approvals', [
      'fileOnFlow'
    ]),
    currentStep() {

    },
    hasSignaturePosition() {
      const {
        detalle: {
          pasos = [],
          ejecucion
        } = {}
      } = this.fileOnFlow;

      const currentStep = pasos
        .find((step) => (
          step.id === ejecucion.pasoActualId
        ));

      return (currentStep &&
        ((currentStep.x && currentStep.x !== '')
          && (currentStep.y && currentStep.y !== '')
          && (currentStep.pagina && currentStep.pagina !== ''))
      );
    },
    isSigner() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion } = detalle;
      return pasos
        .some((step) => (
          step.id === ejecucion.pasoActualId
          && step.paso.aprobacionesTipoRolId === rolTypesCode.firmante
        ));
    },
  },
  watch: {
    file() {
      this.newStep = {};
    }
  },
  methods: {
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async sendAction() {
      const isValid = await this.validateForm('flow-part-1');
      if (!isValid) {
        return;
      }
      const step = {
        tipoValorResponsableId: this.newStep.responsable,
        aprobacionesTipoRolId: this.newStep.rolType,
        aprobacionesTipoPasoId: this.newStep.stepType
      };

      await addStepFlow(this.file.idAprobacion, step);
      await this.$bvToast.toast(
        'Se ha agregado el paso exitosamente',
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.newStep = {};
      this.$emit('close');
    },
    handleOk() {
      this.sendAction();
    },
    cancelAction() {
      this.$emit('close');
    }
  },
  props: {
    file: {
      type: Object,
      required: true,
      default: () => {}
    },
    flowId: {
      type: String
    }
  }
};
</script>
<style>
  .type-resend {
    justify-content: space-evenly;
  }
</style>
